import { buttonVariants, type ButtonProps } from '@/components/buttons/button.props';
import { cn } from '@/lib/utils';
import DownloadCsv from '@/modules/DownloadCsv/DownloadCsv';

export const Button = ({ children, variant, intent, size, className, ...props }: ButtonProps) => {
  return (
    <button className={cn(buttonVariants({ variant, intent, size }), className)} {...props}>
      {children}
    </button>
  );
};

export const PrimaryButton = (props: Omit<ButtonProps, 'intent'>) => Button({ ...props, intent: 'primary' });
export const SecondaryButton = (props: Omit<ButtonProps, 'intent'>) => Button({ ...props, intent: 'secondary' });
export const DestructiveButton = (props: Omit<ButtonProps, 'intent'>) => Button({ ...props, intent: 'destructive' });

type DownloadProps = {
  projectId?: string;
  farmId?: string;
  template?: string;
};

export const DownloadCsvButton = ({ projectId, farmId, template }: DownloadProps) => {
  return <div className={cn('flex gap-2')}>{<DownloadCsv farmId={farmId} projectId={projectId} template={template} />}</div>;
};
